module.exports = __webpack_public_path__ + "static/media/maintenance.b49b3047.svg";